export default {
      id: "icon--santa-trail-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--santa-trail-usage",
      toString: function () {
        return this.url;
      }
    }